import React from "react";
import PropTypes from "prop-types";
import ColumnLocationContext from "../contexts/ColumnLocationContext";
import {ForEachModel} from "@morningtrain/react-resources";

function TableBody(props) {
    return (
        <ColumnLocationContext.Provider value={'cell'}>
            <tbody className={props.className}>
                <ForEachModel>
                    {props.children}
                </ForEachModel>
            </tbody>
        </ColumnLocationContext.Provider>
    );
}

TableBody.defaultProps = {
    className: '',
}

TableBody.propTypes = {
    className: PropTypes.string
}

export default TableBody;
